import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Ciphersuite } from '../models/Ciphersuite';

export class ReportCiphersuiteMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Ciphersuite {
    return new Ciphersuite(
      data.nid,
      data.name,
      data.recommended,
      data.reference ?? [],
      data.version,
      data.modeOfOperation,
      data.kex ?? null,
      data.hashAlg,
      data.auth ?? null,
      data.algorithmSym ?? null,
      data.mac ?? null
    );
  }
}
